import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCollaborators, StateStatus } from '@guryou/redux';

const useCollaborators = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.provider.collaborators);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getCollaborators());
    }
  }, [data, dispatch, status]);

  return { data: data || [], status, version, entity };
};

export default useCollaborators;
